module.exports = __webpack_public_path__ + "static/media/calculator.36c4eab9.svg";